import { useCurrency } from './CurrencyContext';

// Phone numbers by region
const PHONE_NUMBERS = {
  AU: {
    display: '1800 315 152',
    raw: '1800315152',
    prefix: '',
    label: 'Free call (Australia)'
  },
  US: {
    display: '(877) 502-1353',
    raw: '+18775021353',
    prefix: '+1',
    label: 'Toll-free (US)'
  }
};

export function usePhoneNumber() {
  const { currency } = useCurrency();
  
  // If currency is USD, show US number; otherwise AU
  if (currency === 'USD') {
    return PHONE_NUMBERS.US;
  }
  return PHONE_NUMBERS.AU;
}

export { PHONE_NUMBERS };
